<template>
  <section class="container">
    <div v-if="status === 'ready' && isSpreadsheet">
      Aantal regels: {{ file.numberOfLines }}
    </div>
    <div v-else-if="status === 'ready'">
      Formaat: {{ size }}<br />
      Totaal aantalpagina's in bestand:
      {{ file.pagesBW + file.pagesColour + file.pagesBlank }}<br />
      Pagina's kleur: {{ file.pagesColour }}<br />
      Pagina's zwart/wit:
      {{ file.pagesBW }}
      <br /><span v-if="file.pagesBlank > 0"
        >Pagina's blanco: {{ file.pagesBlank }}</span
      >
    </div>
    <div class="fail-msg" v-if="status === 'fail'">
      Dit bestandsformaat kan niet worden geanalyseerd. Hierdoor kunnen wij geen
      prijs tonen.
    </div>
    <div class="fail-msg" v-else-if="status === 'pwprotected'">
      Dit bestand is afgeschermd met een wachtwoord. Hierdoor kunnen wij het
      bestand niet analyseren en geen prijs tonen.
    </div>
  </section>
</template>

<script>
import { matchesFileType } from '@/features/productOrder/ProductOrderMixin'

export default {
  props: ['file'],
  computed: {
    // Spreadsheets have no pages to report on, only rows. Matched on mimeType rather
    // than on numberOfLines, which is sent for every file and depends on analysis timing.
    isSpreadsheet() {
      return matchesFileType(this.file.mimeType, 'excel')
    },
    size() {
      return this.file.format === 'Als bestand'
        ? this.file.dimensions
        : this.file.format
    },
    status() {
      if (this.file.status === 'READY_PASSWORD_PROTECTED') {
        return 'pwprotected'
      } else if (this.file.status === 'READY_NOT_ANALYZED') {
        return 'fail'
      } else if (this.file.status === 'READY') {
        return 'ready'
      } else {
        return 'analyzing'
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

.container {
  font-size: 11px;
  overflow: hidden;

  div {
    padding-top: 5px;
  }
}

.fail-msg {
  padding-top: 10px;
}
</style>
